import { Currency } from '../../../constants/currency';
import type { Condition } from '../../../hooks/useProductData';
import { getAmountString } from '../../humanization';

export const getMarketplaceConditions = (item): Condition[] => {
  // Стоимость, Пробный период
  const conditions = [];

  // стоимость
  const { promo, price } = item;
  if (promo) {
    conditions.push({ value: `${getAmountString(promo)} ₽/мес`, description: 'Стоимость со скидкой' });
  } else if (item.terms === 'mounth') {
    conditions.push({ value: `${getAmountString(price)} ₽/мес`, description: 'Стоимость' });
  } else if (price) {
    conditions.push({ value: `${getAmountString(price, Currency.RUB)}`, description: 'Стоимость' });
  } else {
    conditions.push({ value: `Бесплатно`, description: 'Стоимость' });
  }

  // пробный период
  const { timeStartFree, timeFree } = item;
  if (timeStartFree) {
    conditions.push({ value: `${timeFree}`, description: 'Пробный период' });
  }

  return conditions;
};
